import { render, staticRenderFns } from "./PopupInfo.vue?vue&type=template&id=50c30ff8&scoped=true"
import script from "./PopupInfo.vue?vue&type=script&lang=js"
export * from "./PopupInfo.vue?vue&type=script&lang=js"
import style0 from "./PopupInfo.vue?vue&type=style&index=0&id=50c30ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c30ff8",
  null
  
)

export default component.exports